import { render, staticRenderFns } from "./AppUploadPanel.vue?vue&type=template&id=8b4d2cfa&scoped=true"
import script from "./AppUploadPanel.vue?vue&type=script&lang=js"
export * from "./AppUploadPanel.vue?vue&type=script&lang=js"
import style0 from "./AppUploadPanel.vue?vue&type=style&index=0&id=8b4d2cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4d2cfa",
  null
  
)

export default component.exports